<div class="planning">
  <div class="planning__head" *ngIf="phases.length > 0">
    <span
      aria-hidden="true"
      class="icon"
      [inlineSVG]="'/assets/icons/rocket.svg'"
    ></span>
    <h2>
      {{ 'project.planning.started' | translate }}
      {{ project.startDate | date : 'longDate' : 'UTC+2' }}
    </h2>
  </div>
  <ul
    class="planning__items"
    *ngIf="planningLoaded"
    [@slideIn]="showPastPhases ? 'show' : 'void'"
  >
    <li *ngIf="!showPastPhases">
      <button (click)="showPastPhases = true">
        <span
          aria-hidden="true"
          class="icon"
          inlineSVG="/assets/icons/arrow-up.svg"
        ></span>
        <p>{{ 'project.planning.show-past' | translate }}</p>
      </button>
    </li>
    <ng-container *ngFor="let item of planningItems; let index = index">
      <li
        [class.isPast]="item['isPast']"
        #phaseElement
        [ngClass]="
          item['type'] == 'planning' && {
            first: (item['index'] + 1) % 3 == 1,
            second: (item['index'] + 1) % 3 == 2,
            third: (item['index'] + 1) % 3 == 0
          }
        "
        *ngIf="showPastPhases || !item['isPast']"
      >
        <ng-container *ngIf="item['type'] == 'planning'">
          <div
            class="planning__items__box ion-activatable"
            tabindex="0"
            role="link"
            (click)="openPhase(item)"
          >
            <div *ngIf="item['isCurrent']" class="current">
              <span
                aria-hidden="true"
                inlineSVG="assets/icons/flag-planning.svg"
              ></span>
              <span>{{ 'project.planning.current' | translate }}</span>
            </div>
            <h3>
              {{ item.name }}
            </h3>
            <span>
              {{ item.startDate | dateType : item.startType }} -
              {{ item.endDate | dateType : item.endType }}
            </span>
            <div class="text">
              <div
                [appTranslateText]="item.text | truncate : 300"
                [html]="item.text | truncate : 300"
                [language]="project.language"
              ></div>
            </div>
            <ion-ripple-effect></ion-ripple-effect>
          </div>
          <div
            class="planning__items__events"
            *ngIf="item.events?.length"
            [@slideIn]="item['showPastEvents'] ? 'show' : 'void'"
          >
            <button
              class="event"
              *ngIf="item['hasPastEvents'] && !item['showPastEvents']"
              (click)="$event.stopPropagation(); item['showPastEvents'] = true"
            >
              {{ 'project.planning.show-past-event' | translate }}
            </button>
            <ng-container *ngFor="let event of item.events">
              <app-event
                *ngIf="
                  !event['isPast'] ||
                  (event['isPast'] && item['showPastEvents'])
                "
                [language]="project.language"
                [standalone]="true"
                [class.isPast]="event['isPast']"
                [event]="event"
              >
              </app-event>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="item['type'] == 'event'">
          <app-event
            [language]="project.language"
            [standalone]="true"
            [event]="item"
          ></app-event>
        </ng-container>
      </li>
    </ng-container>
  </ul>

  @if (showEmptyMessage && !showPastPhases) {
  <app-state-notice [desc]="'planning.empty.active.desc' | translate" />
  } @if (phases.length === 0 && planningLoaded) {
  <app-state-notice
    iconPath="/assets/illustrations/no_new_updates.svg"
    [title]="'project.tab.planning' | translate"
    [desc]="'planning.empty.desc' | translate"
  />
  }
</div>
